import { MAX_NAME_LENGTH } from '../constants/validation';
var cropAssignmentName = function (value) {
    return value.substring(0, MAX_NAME_LENGTH);
};
var escapeCyrillicSymbols = function (string) {
    return string.replace(/[А-Яа-я]/g, '');
};
var preprocessAssignmentName = function (value) {
    return cropAssignmentName(escapeCyrillicSymbols(value));
};
export { preprocessAssignmentName };
